import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import { useRef } from "react";
import {
  FieldPath,
  FieldValues,
  Path,
  PathValue,
  useController,
  useFormContext,
} from "react-hook-form";

import { BaseFieldProps } from "../../../components/atoms/FieldProps";
import CalendarIcon from "../../../components/icons/ui-actions/CalendarIcon";
import useIsFieldDisabled from "../../../hooks/formHooks/useIsFieldDisabled";

type Props<TFieldValues extends FieldValues> = {
  dateNotBefore?: Path<TFieldValues>;
  disablePast?: boolean;
} & BaseFieldProps<TFieldValues>;

const DateField = <TFieldValues extends FieldValues>({
  name,
  label,
  disabled = false,
  disabledForEdit = false,
}: Props<TFieldValues>) => {
  const inputRef = useRef<string | undefined | null>();

  const { control } = useFormContext<TFieldValues>();
  const { field } = useController({
    name,
    control,
  });

  const fieldIsDisabled = useIsFieldDisabled(disabled, disabledForEdit);

  const handleChange = (date: Dayjs | null) => {
    const formDate = date ? date.format("DD/MM/YYYY") : null;
    field.onChange(
      formDate as PathValue<TFieldValues, FieldPath<TFieldValues>>,
    );
    inputRef.current = formDate;
  };

  return (
    <Box data-testid={`form-${label}-DATE`} width={"-webkit-fill-available"}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box position="relative">
          <DatePicker
            {...field}
            value={field.value ? dayjs(field.value, "DD/MM/YYYY") : null}
            onChange={handleChange}
            disabled={fieldIsDisabled}
            label={label}
            views={["year", "month", "day"]}
            format="DD/MM/YYYY"
            slots={{
              openPickerIcon: CalendarIcon,
            }}
          />
          {(inputRef.current || field.value) && (
            <Button
              style={{
                padding: 0,
                minWidth: 10,
                position: "absolute",
                right: "22%",
                top: "33%",
              }}
              onClick={() => ((inputRef.current = null), handleChange(null))}
            >
              <CloseIcon style={{ color: "#000", fontSize: "15px" }} />
            </Button>
          )}
        </Box>
      </LocalizationProvider>
    </Box>
  );
};

export default DateField;
